<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  export default {
    name: 'ProductTile',
    props: {
      product: Object,
    },
  }
</script>
